import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { useState } from 'react'

import { LiveEventsProvider } from './live-events'
import { createQueryClient } from './query-client'
import { router } from './router'

export function AppProviders() {
  // 放进 state 是为了让 StrictMode 下的二次渲染不会换掉整个缓存
  const [queryClient] = useState(createQueryClient)

  return (
    <QueryClientProvider client={queryClient}>
      <LiveEventsProvider>
        <RouterProvider router={router} />
      </LiveEventsProvider>
    </QueryClientProvider>
  )
}
